import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModificarReglasAlmacenesAlternativosSocioEnAPI, ObtenerReglasAlmacenesAlternativosSocioEnAPI } from "../../action/actionCreatorsRequests"
import { MSGOK, diaPorNumero, nuevoFormatoFechaCliente, traducirPagina } from '../../librerias/funciones'
import {
    SaveOutlined,
    CloseOutlined

} from '@ant-design/icons';

import { Input, Row, Col, Drawer, Checkbox } from 'antd';
const { TextArea } = Input;

const FichaMantenimientoRegla = ({ props, configApp }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)


    const [hayRegistros, setHayRegistros] = React.useState(false);
    const [idiomasLocal, setIdiomasLocal] = React.useState([]);
    const [repeticionFecha, setRepeticionFecha] = React.useState(true);
    const [repeticionDia, setRepeticionDia] = React.useState(false);


    const [DIA_REPETICION, setDIA_REPETICION] = React.useState([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
    ]);


    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID: null,
            ID_SOCIO: 0,
            ALMACEN: "",
            ALMACEN_ALTERNATIVO: "",
            REPETICION: false,
            DIA_REPETICION: 1,
            FECHA_UNICA: "",
            OBSERVACIONES: ""

        }
    )

    const BuscarAlmacenEnAPI = (ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, ALMACEN) => {
        ObtenerReglasAlmacenesAlternativosSocioEnAPI(ORDERCOLUM, ORDERDIR, ID_SOCIO, ID, ALMACEN).then((cli) => {
            if (cli.REGISTROS !== undefined)
                if (cli.REGISTROS !== null && cli.REGISTROS.length > 0) {
                    let user = cli.REGISTROS[0];
                    setPayLoadLocal({
                        ID: user.ID,
                        ID_SOCIO: user.ID_SOCIO,
                        ALMACEN: user.ALMACEN,
                        ALMACEN_ALTERNATIVO: user.ALMACEN_ALTERNATIVO,
                        REPETICION: user.REPETICION,
                        DIA_REPETICION: user.DIA_REPETICION,
                        FECHA_UNICA: user.FECHA_UNICA !== "" ? nuevoFormatoFechaCliente(user.FECHA_UNICA) : "",
                        OBSERVACIONES: user.OBSERVACIONES,
                    })


                    //setRepeticionFecha(user.DIA_REPETICION)
                    setRepeticionDia(user.DIA_REPETICION ? true : false)
                    setRepeticionFecha(user.DIA_REPETICION ? false : true)
                }
        })
    }


    if (!hayRegistros && props.ESTADO_FICHA) {
        setHayRegistros(true);

        if (Object.keys(props.SELECCIONADO).length > 0) {
            BuscarAlmacenEnAPI(1, "A", props.SELECCIONADO.ID_SOCIO, props.SELECCIONADO.ID, "");
        } else {
            setPayLoadLocal({
                ID: null,
                ID_SOCIO: 0,
                ALMACEN: "",
                ALMACEN_ALTERNATIVO: "",
                REPETICION: false,
                DIA_REPETICION: 1,
                FECHA_UNICA: "",
                OBSERVACIONES: ""
            })
        }


    } else {
        if (!props.ESTADO_FICHA && hayRegistros) {
            props.MODIFICAR_SELECCIONADO({})

            setHayRegistros(false);
            setIdiomasLocal([])
            setPayLoadLocal({
                ID: null,
                ID_SOCIO: 0,
                ALMACEN: "",
                ALMACEN_ALTERNATIVO: "",
                REPETICION: false,
                DIA_REPETICION: 1,
                FECHA_UNICA: "",
                OBSERVACIONES: ""
            })
        }
    }

    const guardarEstadoFormulario = (e) => {

        const ID = e.target.name === 'ID' ? e.target.value : payLoadLocal.ID;
        const ID_SOCIO = e.target.name === 'ID_SOCIO' ? e.target.value : payLoadLocal.ID_SOCIO;
        const ALMACEN = e.target.name === 'ALMACEN' ? e.target.value : payLoadLocal.ALMACEN;
        const ALMACEN_ALTERNATIVO = e.target.name === 'ALMACEN_ALTERNATIVO' ? e.target.value : payLoadLocal.ALMACEN_ALTERNATIVO;
        const REPETICION = e.target.name === 'REPETICION' ? e.target.checked : payLoadLocal.REPETICION;
        const DIA_REPETICION = e.target.name === 'DIA_REPETICION' ? e.target.value : payLoadLocal.DIA_REPETICION;
        const FECHA_UNICA = e.target.name === 'FECHA_UNICA' ? e.target.value : payLoadLocal.FECHA_UNICA;
        const OBSERVACIONES = e.target.name === 'OBSERVACIONES' ? e.target.value : payLoadLocal.OBSERVACIONES
            ;

        setPayLoadLocal(
            {
                ID: ID,
                ID_SOCIO: ID_SOCIO,
                ALMACEN: ALMACEN,
                ALMACEN_ALTERNATIVO: ALMACEN_ALTERNATIVO,
                REPETICION: REPETICION,
                DIA_REPETICION: DIA_REPETICION,
                FECHA_UNICA: FECHA_UNICA,
                OBSERVACIONES: OBSERVACIONES,

            }
        )
    }

    const modificarDia = (e) => {
        payLoadLocal.DIA_REPETICION = e;
        setPayLoadLocal(payLoadLocal)
        //setTextoIdioma(e)
    }


    const crearUsuarioMostrador = () => {

        payLoadLocal.ID_SOCIO = props.ID_SOCIO
        let accion = Object.keys(props.SELECCIONADO).length > 0 ? 1 : 0;


        if (payLoadLocal.REPETICION) {
            payLoadLocal.FECHA_UNICA = null
        } else {
            payLoadLocal.DIA_REPETICION = null
        }



        ModificarReglasAlmacenesAlternativosSocioEnAPI(accion, payLoadLocal).then(usuario => {
            if (usuario !== undefined) {
                if (usuario.OK) {
                    MSGOK(traducirPagina("Regla_creada"))

                    props.ACTUALIZAR_REGLAS(1, "A", payLoadLocal.ID_SOCIO, "", "")
                    props.CERRAR_FICHA(false);

                }
            }
        })

    }
    const tipoRepeticion = (repeticon, TIPO) => {
        if (TIPO === "FECHA") {
            setRepeticionFecha(repeticon)
            setRepeticionDia(!repeticon)
            payLoadLocal.REPETICION = repeticon ? false : true

        } else if (TIPO === "DIA") {
            setRepeticionDia(repeticon)
            setRepeticionFecha(!repeticon)
            payLoadLocal.REPETICION = repeticon ? true : false

        }
    }


    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    }, [])


    return (
        <Drawer
            width={550}
            onClose={() => {
                props.CERRAR_FICHA(false);
            }}
            visible={props.ESTADO_FICHA}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            closable={false}
            style={{ color: '#fff' }}
        >
            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined>
                    <div> {props.title}</div>
                </div>
            </div>


            <div className="m-3"  ref={ref}    >
                <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000', height: `calc(100vh - ${(130 + alturaSubmenu)}px )`, overflow: 'auto' }}>
                    <Col md={24}>
                        <span>{traducirPagina("Info_almacen_editando")} </span>
                    </Col>

                    <Col md={24}>
                        <Input name="ALMACEN" autocomplete="off" value={payLoadLocal.ALMACEN} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>

                    <Col md={24} style={{ marginTop: '40px' }}>
                        <span>{traducirPagina("Info_almacen_anterior")} </span>
                    </Col>

                    <Col md={24}>
                        <Input name="ALMACEN_ALTERNATIVO" type="text" autocomplete="off" value={payLoadLocal.ALMACEN_ALTERNATIVO} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>

                    <Col md={24} style={{ marginTop: '40px' }}>
                        <span>{`${traducirPagina("Regla_realizara")}: `} </span>
                    </Col>

                    <Col md={22}  >
                        <Col md={8} style={{ marginBottom: '10px' }}>
                            <Checkbox checked={repeticionFecha} onChange={(e) => { tipoRepeticion(e.target.checked, "FECHA") }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Una_vez")}</span> </Checkbox>
                        </Col>

                        <Col md={16} style={{ marginBottom: '10px' }}>
                            <input disabled={repeticionDia} type="date" name="FECHA_UNICA" value={payLoadLocal.FECHA_UNICA} onChange={(e) => guardarEstadoFormulario(e)} style={{ width: '150px' }}></input>
                        </Col>

                        <Col md={8} style={{ marginBottom: '10px' }}>
                            <Checkbox checked={repeticionDia} onChange={(e) => { tipoRepeticion(e.target.checked, "DIA"); payLoadLocal.DIA_REPETICION = 1 }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Cada")}</span> </Checkbox>
                        </Col>

                        <Col md={16} style={{ marginBottom: '10px' }}>
                            {DIA_REPETICION !== null ?
                                <select disabled={repeticionFecha} value={payLoadLocal.DIA_REPETICION} className="custom-select" name="DIA_REPETICION"
                                    style={{ width: '150px' }}
                                    onChange={(e) => { guardarEstadoFormulario(e) }}>
                                    {DIA_REPETICION.length > 0 ?
                                        DIA_REPETICION.map((dia) =>
                                            <option key={dia} value={dia}>{diaPorNumero(dia)}</option>
                                        )
                                        :
                                        null
                                    }
                                </select>
                                :
                                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                    <h4>{traducirPagina("Info_error_idioma")}</h4>
                                </div>
                            }
                        </Col>
                    </Col>

                    <Col md={24} style={{ marginTop: '40px' }}>
                        <span>{traducirPagina("Observaciones")}</span>
                    </Col>

                    <Col md={24}>
                        <TextArea rows={8} name="OBSERVACIONES" value={payLoadLocal.OBSERVACIONES} onChange={(e) => guardarEstadoFormulario(e)} />
                    </Col>
                </Row>

            </div>


            <div className="menu_mantenimiento"  style={{padding:'0px 16px 16px 16px'}}>
                <div className="mantenimiento_item1"></div>
                <div className="mantenimiento_item2">
                    <div className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }} onClick={() => {
                        crearUsuarioMostrador()
                    }}>
                        <SaveOutlined /> {traducirPagina("Guardar_salir")}
                    </div>
                </div>
            </div>




        </Drawer>
    )
}


FichaMantenimientoRegla.propTypes = {
    title: PropTypes.string,
    idDocumento: PropTypes.number,
    LICENCIAS: PropTypes.array,
    ESTADO_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    ID_USUARIO: PropTypes.number,
    ACTUALIZAR_REGLAS: PropTypes.func,
    TEXTO_BUSCADOR: PropTypes.func,
    SELECCIONADO: PropTypes.object,
    MODIFICAR_SELECCIONADO: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        VehiculoTallerSeleccionado: state.VehiculoTallerSeleccionado,
        datosFacturacion: state.datosFacturacion
    };
}

export default connect(mapStateToProps)(FichaMantenimientoRegla);